<template lang="pug">
div.sidebar-banner__live-plan
  h3.sidebar-banner__live-plan--title 配信予定
  ul.sidebar-banner__live-plan--list
    li.sidebar-banner__live-plan--item(v-for='value in values')
      div.sidebar-banner__live-plan--date-container
        span.sidebar-banner__live-plan--date {{ value.start_date | modifyStartDate }}
        span.sidebar-banner__live-plan--day {{ value.start_date | modifyStartDay }}
        span.sidebar-banner__live-plan--time {{ value.start_date | modifyStartTime }}{{ value.end_date | modifyEndTime }}
      div.sidebar-banner__live-plan--text
        a.sidebar-banner__live-plan--text-title(:href='value.facebook_url', targer='_blank', rel='noopner') {{value.title}}
        p.sidebar-banner__live-plan--text-company-name {{value.company_name}}
  </div>
</template>

<script>
import { getPeriodStartTime, getPeriodEndTime } from './../../utilities/modifyTime';

export default {
  name: 'AddLivePlanElement',
  props: {
    valueProps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    values: {
      get () {
        return this.valueProps;
      },
      set (newValue) {
        this.$emit('update:valueProps', newValue);
      }
    }
  },
  filters: {
    modifyStartDay: function (time) {
      return getPeriodStartTime(time).startDay;
    },
    modifyStartDate: function (time) {
      return getPeriodStartTime(time).startDate;
    },
    modifyStartTime: function (time) {
      const start = getPeriodStartTime(time);
      return `${start.startTime} 〜 `;
    },
    modifyEndTime: function (time) {
      return getPeriodEndTime(time);
    }
  }
};
</script>
